import { render, staticRenderFns } from "./MainAuth.vue?vue&type=template&id=ac74a33a&"
import script from "./MainAuth.vue?vue&type=script&lang=js&"
export * from "./MainAuth.vue?vue&type=script&lang=js&"
import style0 from "./MainAuth.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports